import { getCookieByName } from './index'
import { getStorageValue } from '@helpers/hooks/useStorage'

export const getUserLoggedInCookie = () => getCookieByName('customerId')

export const getIsUserLoggedIn = () => !!getUserLoggedInCookie()

export const getUserSavedFitData = () => getCookieByName('saved_fit')

export const getUserEmail = () => {
  const userTraits = getStorageValue('localStorage', 'ajs_user_traits', {})

  return 'email' in userTraits ? (userTraits.email as string) : undefined
}

export const getIsFirstTimeUser = () =>
  !getCookieByName('th_LV') || !!getCookieByName('th_ftv')

export const getUserPseudoTokenCookie = (): string | undefined =>
  getCookieByName('token')

export const getCustomerId = () => getUserLoggedInCookie() || undefined

export function getUserDataFromAnalytics(): {
  id: string | null
  traits:
    | (Partial<{ email: string; firstName: string }> & Record<string, string>)
    | Record<string, never>
} {
  const userId = getStorageValue('localStorage', 'ajs_user_id', null)
  const userAnonymousId = getStorageValue(
    'localStorage',
    'ajs_anonymous_id',
    null
  )
  const userTraits = getStorageValue('localStorage', 'ajs_user_traits', {})

  return {
    id: userId || userAnonymousId,
    traits: {
      ...userTraits
    }
  }
}
